import { AWStageDto } from '@api/Api';
import React, { memo, useMemo } from 'react';
import AvatarsGroup from '@components/AvatarsGroup/AvatarsGroup';

type ManagersCellProps = {
  stages: AWStageDto[];
};

export default memo(function ManagersCell({ stages }: ManagersCellProps) {
  const users = useMemo(() => {
    const users = (stages || [])
      .map((el) => el.members)
      .flat()
      .filter((user) => user.canManageAW);

    const uniqueMembers = [
      ...new Map(users.map((user) => [user.email, user])).values()
    ];
    return uniqueMembers;
  }, [stages]);
  return (
    <AvatarsGroup
      maxCount={3}
      avatarSize={32}
      users={users}
      membersType="aw_stage_members"
    />
  );
});
